
<template>
  <div class="dynamic-image-container">
    <div
      class="action-content"
    >
      <div class="action-back">
        <img :src="content.cover" alt="">
      </div>
      <div class="action-list" ref="container">
        <div
          class="action-item"
          v-for="(item, index) in handleData"
          :key="index"
          v-draggable
        >
          <el-image class="drag-handle" :src="item.cover" :alt="item.title" :title="item.title"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

/*
交互 --- 动态图片
*/
export default {
  name: "dynamicImage",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      handleData: [],
    }
  },
  mounted() {
    this.handleData = this.content.content;
  },
  methods: {
    
  },
  //自定义指令
  directives: {
    draggable: {
      // 指令的定义
      inserted: function (el, binding, vnode) {
        // 获取到vue实例
        let that = vnode.context;
        let drag_dom = el;
        // 获取到拖拽区
        let drag_handle = el.querySelector(".drag-handle");
        // 鼠标在拖拽区按下时触发拖拽
        drag_handle.onmousedown = (e) => {
          // 按下鼠标时，鼠标相对于被拖拽元素的坐标
          let disX = e.clientX - drag_dom.offsetLeft;
          let disY = e.clientY - drag_dom.offsetTop;

          // 获取容器dom
          let container_dom = that.$refs.container;

          document.onmousemove = (e) => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;

            // 在容器范围内移动时，被拖拽元素的最大left值
            let leftMax =
              container_dom.offsetLeft +
              (container_dom.clientWidth - drag_dom.clientWidth);

            // 在容器范围内移动时，被拖拽元素的最小left值
            let leftMin = container_dom.offsetLeft + 1; //此处+1为容器的边框1px

            if (left > leftMax) {
              drag_dom.style.left = leftMax + "px";
            } else if (left < leftMin) {
              drag_dom.style.left = leftMin + "px";
            } else {
              drag_dom.style.left = left + "px";
            }

            // 在容器范围内移动时，被拖拽元素的最大left值
            let topMax =
              container_dom.offsetTop +
              (container_dom.clientHeight - drag_dom.clientHeight);

            // 在容器范围内移动时，被拖拽元素的最小left值
            let topMin = container_dom.offsetTop + 1; //此处+1为容器的边框1px

            if (top > topMax) {
              drag_dom.style.top = topMax + "px";
            } else if (top < topMin) {
              drag_dom.style.top = leftMin + "px";
            } else {
              drag_dom.style.top = top + "px";
            }
          };

          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
}
</script>


<style lang="scss" scoped>
.dynamic-image-container{

  .action-content{
    width: 100%;
    min-height: 300px;
    margin: 0 auto;
    display: flex;
    position: relative;
    
    .action-back{
      width: 100%;
      height: 300px;
      display: flex;
      align-items: center;
      justify-content: center;

      img{
        max-height: 100%;
        max-width: 100%;
        display: block;
      }
    }

    .action-list{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      .action-item{
        width: 100px;
        display: flex;
        align-items: center;
        position: relative;
        position: absolute;

        img{
          display: block;
          max-width: 100px;
          max-height: 100px;
        }

        &:nth-child(1){
          top: 100px;
          left: 100px;
        }
        &:nth-child(2){
          top: 200px;
          left: 100px;
        }
        &:nth-child(3){
          top: 50px;
          right: 150px;
        }
        &:nth-child(4){
          top: 150px;
          right: 100px;
        }
        &:nth-child(5){
          top: 200px;
          right: 200px;
        }
      }
    }
  }
}
</style>
